import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";

const BorderedLayout = ({
  children,
  title,
  backgroundColor = "#fff",
}: {
  children: ReactNode;
  title?: string | ReactNode;
  backgroundColor?: string;
}) => {
  return (
    <Box
      sx={{
        border: "1px solid #DAE0E4",
        borderRadius: "5px",
        width: "100%",
        height: "100%",
        padding: "20px",
        position: "relative",
        backgroundColor: { backgroundColor },
      }}
      // padding={{ xs: "0", md: "20px" }}
    >
      <Typography
        sx={{
          fontSize: "1.1rem",
          fontWeight: "bold",
          color: "#1D4A87",
          position: "absolute",
          marginTop: "-32px",
          width: "fit-content",
          paddingInline: "3px",
          backgroundColor: "#fff",
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default BorderedLayout;
